import React, { FC } from "react";
import { Form, Stack } from "react-bootstrap";
import { useDisableEnableControllerMutation } from "features/api/usersPermissionsManagement/usersPermissionsManagementApiSlice";
import { controllerData } from "./controllerTypes";

type Props = {
  controller: controllerData;
};

const DisableCheckbox: FC<Props> = ({ controller }) => {
  const [disableEnableController] = useDisableEnableControllerMutation();

  const HandleChangeCheckbox = async (
    controllerId: string,
    isDisable: boolean
  ) => {
    await disableEnableController({ controllerId, isDisable }).unwrap();
  };

  return (
    <Stack direction="horizontal" className="disable-checkbox" gap={0}>
      <Form.Check
        type="switch"
        id="custom-switch"
        checked={controller?.disable}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          HandleChangeCheckbox(controller?.id, event.target.checked);
        }}
        size={20}
      />
    </Stack>
  );
};

export default DisableCheckbox;
